import Countries from 'pages/config/Countries';
import { FormFieldsConfig } from '../../components/Form/FormEntities';

const RegistrationFormConfig: FormFieldsConfig = {
  gender: {
    default: 'm',
    constraints: ['required'],
    options: [
      {
        label: 'male',
        value: 'm',
      },
      {
        label: 'female',
        value: 'f',
      },
    ],
  },
  language: {
    default: 'fr',
    constraints: ['required'],
    options: [
      {
        label: 'french',
        value: 'fr',
      },
      {
        label: 'english',
        value: 'en',
      },
    ],
  },
  firstName: {
    constraints: ['required'],
  },
  lastName: {
    constraints: ['required'],
  },

  profession: {
    default: 'dentist_surgeon',
    constraints: ['required'],
    options: [
      {
        label: 'dentist_surgeon',
        value: 'dentist_surgeon',
      },
      {
        label: 'ophthalmologist',
        value: 'ophthalmologist',
      },
      {
        label: 'plastic_surgeon',
        value: 'plastic_surgeon',
      },
      {
        label: 'cosmetic_doctor',
        value: 'cosmetic_doctor',
      },
    ],
  },
  specialty: {
    default: '',
    options: function (value: string) {
      const allOptions: Record<string, Array<Record<string, string>>> = {
        dentist_surgeon: [
          { label: 'general_dentist', value: 'general_dentist' },
          { label: 'endodontist', value: 'endodontist' },
          {
            label: 'maxillofacial_sugeon',
            value: 'maxillofacial_sugeon',
          },
          { label: 'orthodontist', value: 'orthodontist' },
          { label: 'periodontist', value: 'periodontist' },
          { label: 'pedodontist', value: 'pedodontist' },
        ],

        plastic_surgeon: [
          { label: 'plastic_surgeon', value: 'plastic_surgeon' },
        ],
        cosmetic_doctor: [
          { label: 'cosmetic_doctor', value: 'cosmetic_doctor' },
        ],
        ophthalmologist: [
          { label: 'ophthalmologist', value: 'ophthalmologist' },
        ],
      };
      return allOptions[value];
    },
  },
  country: {
    default: Object.keys(Countries)[0],
    constraints: ['required'],
    options: Object.keys(Countries).map((code) => ({
      label: Countries[code].label,
      value: code,
    })),
  },
  city: {
    default: '',
    constraints: ['required'],
    options: [],
  },
  postCode: {
    default: '',
  },
  boxNumber: {
    default: '',
    constraints: ['required'],
  },
  box: {
    default: '',
  },
  address: {
    constraints: ['required'],
  },
  phone: {
    constraints: [
      {
        message: {
          name: 'string_equal_length',
          params: {
            length: '10',
          },
        },
        validation: (value: string, values: any) =>
          value === '' || value.length === 10,
      },
    ],
  },
  mobile: {
    constraints: [
      'required',
      {
        message: {
          name: 'string_equal_length',
          params: {
            length: '10',
          },
        },
        validation: (value: string, values: any) =>
          value === '' || value.length === 10,
      },
    ],
  },
  email: {
    constraints: ['required', 'email'],
  },
  emailConfirmation: {
    constraints: [
      'required',
      {
        message: 'email_confirmation',
        validation: (val: string, values: any) =>
          !('email' in values) || val === values.email,
      },
    ],
  },
};

export default RegistrationFormConfig;
